import React from "react";

const Skills = (props) => {
  return (
    <div id={props.isNightMode ? "dark" : "light"} className="skills-container">
      <h2 id={props.isNightMode ? "dark" : "light"}>Skills</h2>
      <div className="skills-skills-container">
        <div className="skills-piece">
          <img src="js.svg" alt="JavaScript Logo" />
          <p className="p1">JavaScript</p>
        </div>
        <div className="skills-piece">
          <img src="react.svg" alt="React Logo" />
          <p className="p1">React</p>
        </div>{" "}
        <div className="skills-piece">
          <img src="redux.svg" alt="Redux Logo" />
          <p className="p1">Redux</p>
        </div>{" "}
        <div className="skills-piece">
          <img src="node.svg" alt="Node Logo" />
          <p className="p1">Node</p>
        </div>{" "}
        <div className="skills-piece">
          <img src="vscode.svg" alt="Vscode Logo" />
          <p className="p1">Vs Code</p>
        </div>{" "}
        <div className="skills-piece">
          <img src="figma2.svg" alt="figma Logo" />
          <p className="p1">figma</p>
        </div>
      </div>
    </div>
  );
};

export default Skills;
